import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureQuizOpions } from "../../../../services/dashboard/apiQuizes";

export function useQuizOptions({
  courseId,
  lectureId,
  itemId,
  questionId,
  filter,
  fields,
  includeFields,
  perPage,
  searchValue,
  sortBy,
  page,
  filterAndSortAndPageQuery,
} = {}) {
  const queryClient = useQueryClient();

  const {
    data: quizOptions,
    isPending,
    isSuccess,
  } = useQuery({
    queryKey: [
      "quizOptionsDB",
      courseId,
      lectureId,
      itemId,
      questionId,
      filter,
      fields,
      includeFields,
      perPage,
      searchValue,
      sortBy,
      page,
      filterAndSortAndPageQuery,
    ],
    queryFn: () =>
      getLectureQuizOpions({
        courseId,
        lectureId,
        itemId,
        questionId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      }),
  });

  const totalPages = Math.ceil(
    quizOptions?.meta?.total / quizOptions?.meta?.per_page
  );

  // PRE-FETCHING;
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "quizOptionsDB",
        courseId,
        lectureId,
        itemId,
        questionId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getLectureQuizOpions({
          courseId,
          lectureId,
          itemId,
          questionId,
          filter,
          fields,
          includeFields,
          perPage,
          searchValue,
          sortBy,
          page,
          filterAndSortAndPageQuery,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "quizOptionsDB",
        courseId,
        lectureId,
        itemId,
        questionId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getLectureQuizOpions({
          courseId,
          lectureId,
          itemId,
          questionId,
          filter,
          fields,
          includeFields,
          perPage,
          searchValue,
          sortBy,
          page,
          filterAndSortAndPageQuery,
        }),
    });
  }

  return { isPending, quizOptions };
}
